import { ServiceResponse } from "@sdbn/common";

export enum StationDetailsView {
  ONGOING_MOVEMENT_ORDER_TO_STATION, ONGOING_MOVEMENT_ORDER_FROM_STATION, STATION_OCCUPIED, STATION_DISABLED
}

export enum CompletionOptionType {
  NO_FURTHER_PROCESSING = 'NO_FURTHER_PROCESSING', COMPLETE_ON_WAITING_AREA = 'COMPLETE_ON_WAITING_AREA', FORWARD_TO_NEXT_PROCESSING_STATION = 'FORWARD_TO_NEXT_PROCESSING_STATION'
}

export enum MovementOrderMovingStrategy {
  CLEAR_GATE = 'CLEAR_GATE', LESS_MOVEMENT = 'LESS_MOVEMENT'
}

export class CreateMovementOrder {
    currentStationId: number;
    transportId: number;
    completionOption: CompletionOptionType;
    movementStrategy: MovementOrderMovingStrategy;
}

export class CancelMovementOrder {
  currentStationId: number;
  transportId: number;
  ongoingMovementFromStation: boolean;
  ongoingMovementToStation: boolean;
}

export class CRequestVehicleToStationByTransportCreationProfile {
    targetStationId: number;
    transportCreationProfileId: number;
}

export enum MovementOrderProcessingStatus {
  OPEN = 'OPEN', STARTED = 'STARTED',
	MOVEMENT_STARTED = 'MOVEMENT_STARTED',
	MOVEMENT_COMPLETED = 'MOVEMENT_COMPLETED',
	COMPLETED = 'COMPLETED',
	CANCELED = 'CANCELED'
}

export class CMovementOrder {

	 id: number;
	priority: boolean;
	 referenceDate: string;
	 scope: string;
	 identifier: string;
	 transportReference: string;
	 processingStatus: MovementOrderProcessingStatus;
	 currentStation: string;
	 targetStation: string;

  constructor(movementOrder: any) {
    this.id = movementOrder.id;
    this.priority = movementOrder.priority;
    this.referenceDate = movementOrder.referenceDate;
    this.scope = movementOrder.scope;
    this.identifier = movementOrder.identifier;
    this.transportReference = movementOrder.transportReference;
    this.processingStatus = movementOrder.processingStatus;
    this.currentStation = movementOrder.currentStation;
    this.targetStation = movementOrder.targetStation;
  }
}

export class CAvailableMovementOrders extends ServiceResponse {
  movementOrders: Array<CMovementOrder>;
}

export class ForwardToProcessAction {
  transportOptionIds: Array<number>;
  currentStationId: number;
  transportId: number;
}

